<template>
    <div class="page">
        <ion-grid fixed v-if="baySetup">
            <ion-row class="row-divider"></ion-row>
            <ion-row class="rectangle">
                <ion-col>
                    <ion-row align-items-stretch>
                        <ion-col class="col-padding">
                            <ion-label class="section-head">Charging Station &amp; Charger</ion-label>
                        </ion-col>
                    </ion-row>
                    <ion-row align-items-stretch>
                        <ion-col size="12" size-md="3" class="col-padding">
                            <ion-row align-items-stretch @click="viewStation(baySetup.station.id)">
                                <ion-col size="12">
                                    <ion-label class="section-item" position="stacked">Station ID</ion-label>
                                    <div class="section-desc margin-top-10 select-cahrger-station">{{baySetup.station.id}}</div>
                                </ion-col>
                            </ion-row>
                            <ion-row align-items-stretch>
                                <ion-col size="12">
                                    <ion-label class="section-item" position="stacked">Station Name</ion-label>
                                    <div class="section-desc margin-top-10">{{baySetup.station.name}}</div>
                                </ion-col>
                            </ion-row>
                            <ion-row align-items-stretch>
                                <ion-col size="12">
                                    <ion-label class="section-item" position="stacked">Status</ion-label>
                                    <div
                                        class="section-desc margin-top-10"
                                        v-bind:class="[{'status-active': baySetup.station.status.id == 'A'}, {'status-inactive': baySetup.station.status.id == 'I'}, {'status-extinct': baySetup.station.status.id == 'X'}, {'status-greenfield': baySetup.station.status.id == 'G'}]"
                                    >{{convertUppercase(baySetup.station.status.name)}}</div>
                                </ion-col>
                            </ion-row>
                        </ion-col>
                        <ion-col size="12" size-md="3" class="col-padding">
                            <ion-row align-items-stretch @click="viewCharger(baySetup.charger.id)">
                                <ion-col size="12">
                                    <ion-label class="section-item" position="stacked">Charger ID</ion-label>
                                    <div class="section-desc margin-top-10 select-cahrger-station" style="cursor: pointer;">{{baySetup.charger.id}}</div>
                                </ion-col>
                            </ion-row>
                            <ion-row align-items-stretch>
                                <ion-col size="12">
                                    <ion-label class="section-item" position="stacked">Manufacturer</ion-label>
                                    <div class="section-desc margin-top-10">{{baySetup.charger.manufacturer}}</div>
                                </ion-col>
                            </ion-row>
                            <ion-row align-items-stretch>
                                <ion-col size="12">
                                    <ion-label class="section-item" position="stacked">Status</ion-label>
                                    <div
                                        class="section-desc status-small margin-top-10"
                                        v-bind:class="[{'new': baySetup.charger.status.id == 'A'}, {'new': baySetup.charger.status.id == 'PND'}, {'status-removed': baySetup.charger.status.id == 'RMV'}, {'inactive': baySetup.charger.status.id == 'RET'}, {'installed': baySetup.charger.status.id == 'INS'}, {'installed': baySetup.charger.status.id == 'I'}]"
                                    >{{convertUppercase(baySetup.charger.status.name)}}</div>
                                </ion-col>
                            </ion-row>
                        </ion-col>
                        <ion-col size="12" size-md="3" class="col-padding">
                            <ion-row align-items-stretch>
                                <ion-col size="12">
                                    <ion-label class="section-item" position="stacked">Effective From</ion-label>
                                <div class="section-desc margin-top-10">{{changeDateFormatWithoutTime(baySetup.effectiveOn)}}</div>
                                </ion-col>
                            </ion-row>
                            <ion-row align-items-stretch>
                                <ion-col size="12">
                                    <ion-label class="section-item" position="stacked">Last Effective Date</ion-label>
                                    <div
                                        class="section-desc margin-top-10"
                                    >{{changeDateFormatWithoutTime(baySetup.effectiveTill)}}</div>
                                </ion-col>
                            </ion-row>
                            <ion-row align-items-stretch>
                                <ion-col size="12">
                                    <ion-label class="section-item" position="stacked">Status</ion-label>
                                    <div
                                        class="section-desc status-small margin-top-10"
                                        v-bind:class="[{'status-active': baySetup.status.id == 'A'}, {'status-inactive': baySetup.status.id == 'I'}, {'status-retired': baySetup.status.id == 'R'}]"
                                    >{{convertUppercase(baySetup.status.name)}}</div>
                                </ion-col>
                            </ion-row>
                        </ion-col>
                    </ion-row>
                    <hr />
                    <ion-row align-items-stretch>
                        <ion-col class="col-padding">
                        <ion-label class="section-head">Designated Bay/Port No</ion-label>
                        </ion-col>
                    </ion-row>
                    <ion-row align-items-stretch
                        v-for="(outlet, outputIndex) in baySetup.outlets"
                        :key="outputIndex"
                        >
                        <ion-col
                            size="12"
                            size-md="12"
                            class="col-padding"
                            >
                            <ion-row align-items-stretch>
                                <ion-col size="3">
                                    <ion-label class="section-head">Output Name {{outputIndex + 1}}</ion-label>
                                    <div class="margin-top-10">
                                        <div class="section-desc margin-top-10">{{outlet.name}}</div>
                                    </div>
                                </ion-col>
                                <ion-col size="3"
                                    v-for="(gun, gunIndex) in outlet.guns" :key="gunIndex"
                                    >
                                    <ion-label class="section-head">Port Name {{gunIndex + 1}}</ion-label>
                                    <div class="margin-top-10">
                                        <div class="section-desc margin-top-10">{{gun.name}}</div>
                                    </div>
                                </ion-col>
                            </ion-row>        
                            <ion-row align-items-stretch>
                                <ion-col class="col-padding">
                                    <ion-grid>
                                        <ion-row>
                                            <ion-col class="section-head">
                                                <b>Tariff</b>
                                            </ion-col>
                                            <ion-col class="section-head">
                                                <b>Effective From Date</b>
                                            </ion-col>
                                            <ion-col class="section-head">
                                                <b>Last Effective Date</b>
                                            </ion-col>
                                        </ion-row>
                                        <ion-row 
                                            v-for="(tariff, tariffIndex) in outlet.tariffs" :key="tariffIndex"
                                            >
                                            <ion-col>
                                                <div class="margin-top-10">                        
                                                <label v-bind:class="[{'inactive-tariff-column section-desc' : tariff.status.id == 'I'}, {'section-desc' : tariff.status.id != 'I'}]">{{tariff.tariffCode}}</label>
                                                </div>
                                            </ion-col>
                                            <ion-col>
                                                <div class="margin-top-10 datepicker-web">
                                                <label v-bind:class="[{'inactive-tariff-column section-desc' : tariff.status.id == 'I'}, {'section-desc' : tariff.status.id != 'I'}]">{{changeDateFormatWithoutTime(tariff.effectiveOn)}}</label>
                                                </div>
                                            </ion-col>
                                            <ion-col>
                                                <div class="margin-top-10 datepicker-web">
                                                <label v-bind:class="[{'inactive-tariff-column section-desc' : tariff.status.id == 'I'}, {'section-desc' : tariff.status.id != 'I'}]">{{changeDateFormatWithoutTime(tariff.effectiveTill)}}</label>
                                                </div>
                                            </ion-col>
                                        </ion-row>
                                    </ion-grid>
                                </ion-col>
                            </ion-row>
                            <ion-row v-if="outlet.cmsTagNo && outlet.qrCodeValue">
                                <ion-col size="12" size-md="3" class="col-padding">
                                    <ion-label class="section-item" position="stacked">CMS Tag No</ion-label>
                                    <div class="margin-top-10">
                                        <div class="section-desc margin-top-10">{{outlet.cmsTagNo}}</div>
                                    </div>
                                </ion-col>
                                <ion-col size="12" size-md="3" class="col-padding">
                                    <ion-label class="section-item" position="stacked">QR Code</ion-label><br>
                                    <qrcode-vue v-bind:value="outlet.qrCodeValue" size="50"></qrcode-vue>
                                </ion-col>
                                <ion-col size="12" size-md="3" class="col-padding">
                                    <ion-label class="section-item" position="stacked">Download QR Code</ion-label><br>
                                    <!-- <p>Download</p> -->
                                    <ion-button class="btn-download" @click="downloadQRCode(outlet.qrCodeValue)" v-if="displayInd">
                                        <ion-icon :icon="download"></ion-icon>Download
                                    </ion-button>
                                </ion-col>
                            </ion-row>
                            <hr class="thick-line" />
                        </ion-col>
                    </ion-row>
                </ion-col>
            </ion-row>
        </ion-grid>
        <div class="spinner">
            <ion-spinner v-if="loaderTab"></ion-spinner>
        </div>
    </div>
</template>

<script>
import { defineComponent } from "vue";
import { IonGrid, IonRow, IonCol, IonLabel, IonSpinner, IonIcon } from "@ionic/vue";
import { download } from 'ionicons/icons';
import { EVCStationService } from "../../service/evcstation/stations.service";
import { EVChargerService } from "../../service/evcstation/charger.service";
import { EVCharger, EVChargerStatus } from "../../entity/station/evcharger";
import QrcodeVue from 'qrcode.vue';
import { axios } from '@/service';
import { config } from "../../config";
import moment from "moment";
import { ToastUtils } from "../../util/toast-utils";
import { tryParseServiceError, migratedTryParseServiceError } from "../../service";

export default defineComponent ({
    name: 'chargerInstallationView',
    components: {
        IonGrid, IonRow, IonCol, IonLabel, IonSpinner,QrcodeVue, IonIcon
    },
    data() {
        return {
            download,
            QrcodeVue,
            loaderTab: true,
            baySetup: null,
            displayInd: true
        }
    },
    async mounted() {
        let bayStationInfo = JSON.parse(localStorage.getItem("bayStationInfo"))
        if(localStorage.getItem('user.roleId') == 4) {
            this.displayInd = false;
            if(bayStationInfo.stationId == undefined) {
                let stationId = JSON.parse(localStorage.getItem('branchStationInfo'));
                bayStationInfo.stationId = stationId.stationId;
            }
        }
        if(bayStationInfo.stationId != undefined) {
            try {
                let baySetup = await new EVCStationService().baySetupWithIdOfStation(
                bayStationInfo.bayId,
                {id: bayStationInfo.stationId}
                );
                this.baySetup = baySetup;
                this.loaderTab = false;
            } catch(error) {
                this.loaderTab = false;
                // new ToastUtils().presentToast(error.response.data.errors[0].detail);
                let serviceError = migratedTryParseServiceError(error);
                new ToastUtils().presentToast(serviceError.description);
            }
            
        }
        
    },
    methods: {
        changeDateFormat(dateValue) {
            return moment(dateValue).format('DD/MMM/YYYY HH:mm')
        },
        changeDateFormatWithoutTime(dateValue) {
        
        if(dateValue != null) {
            return moment(dateValue).format('DD/MMM/YYYY')
        }
        
        },
        convertUppercase(value) {
            return value.toUpperCase()
        },
        editChargerBay() {
            this.$parent.editChargerInstall();
        },
        getEncrpQR(qrCode) {
            let qrVal = btoa(qrCode);
            return qrVal;
        },
        viewCharger(chargerId) {
            this.$router.push({
                name: "chargerView",
                params: { chargerId: chargerId }
            });
        },
        viewStation(stationId) {
            this.$router.push({
                name: "chargingStationView",
                params: { stationId: stationId }
            });
        },
        async downloadQRCode(qrCodeValue) {
            let result = await new EVCStationService().downloadQRCodeFromSever(qrCodeValue);
            axios({
                url : config.api.host+result.data.links+result.data.data[0],
                method: 'GET',
                responseType: 'blob'
            }).then((response) => {
                var fileurl = window.URL.createObjectURL(new Blob([response.data]));
                var fileLink = document.createElement("a");
                fileLink.href = fileurl;
                fileLink.setAttribute("download", result.data.data[0]);
                document.body.appendChild(fileLink);
                fileLink.click();
            }).catch((error) => {
                this.loaderTab = false;
                let serviceError = migratedTryParseServiceError(error);
                new ToastUtils().presentToast(serviceError.description); 
            })
        }
    }
})
</script>

<style scoped>
.btn-secondary {
  height: 47px;
  --background: #21315d !important;
  color: #ffffff;
  border-radius: 3px;
  --background-focused: #21315d !important;
  --background-hover: #21315d !important;
  --webkit-background-focused: #21315d !important;
  --webkit-background-hover: #21315d !important;
}
.inactive-tariff-column{
  color: #ff0000 !important;
}
.btn-download{
    margin-left: 10px;
}

.select-cahrger-station{
    width: 85px;
    padding-left: 10px;
    padding-right: 10px;
    background: #21b24b 0% 0% no-repeat padding-box;
    border-radius: 3px;
    text-align: left;
    font-family: "Roboto";
    font-size: 11px;
    letter-spacing: 0;
    color: #ffffff;
    opacity: 1;
    cursor: pointer;
}
</style>